import JobList from '@/components/JobList'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		vouchers: [],
		...opts,
		vueComponent: JobList
	}

	let page = vuewidget(dom, options)
	return page
}
